import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxButtonComponent, DxLookupComponent } from 'devextreme-angular';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';

@Component({
  selector: 'app-popup-scelta-matricola',
  templateUrl: './popup-scelta-matricola.component.html',
  styleUrls: ['./popup-scelta-matricola.component.scss'],
  imports: [DxButtonComponent, DxLookupComponent],
  standalone: true,
})
export class PopupSceltaMatricolaComponent {
  @Input() listMatricole: ArticoliMatricola[];
  @Output() idMatricolaEventEmitter = new EventEmitter<number>();

  idMatricola: number;


  onAnnullaMatricola() {
    this.idMatricolaEventEmitter.emit(null);
  }
  onScegliMatricola() {
    this.idMatricolaEventEmitter.emit(this.idMatricola);
  }

}
